import { CongratsBoxActionTypes } from "./constants";

interface CongratsBoxActionType {
  type:
    | CongratsBoxActionTypes.API_RESPONSE_SUCCESS
    | CongratsBoxActionTypes.API_RESPONSE_ERROR
    | CongratsBoxActionTypes.CREATE_CONGRATS
    | CongratsBoxActionTypes.UPDATE_CONGRATS
    | CongratsBoxActionTypes.GET_CONGRATS
    | CongratsBoxActionTypes.DELETE_CONGRATS;
  payload: {} | string;
}

// common success
export const CongratsBoxApiResponseSuccess = (
  actionType: string,
  data: any | {}
): CongratsBoxActionType => ({
  type: CongratsBoxActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const CongratsBoxApiResponseError = (
  actionType: string,
  error: string
): CongratsBoxActionType => ({
  type: CongratsBoxActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createCongratsBox = (
  heading: string,
  heading_ar: string,
  sub_text : string,
  sub_text_ar : string,
  file: any
): CongratsBoxActionType => ({
  type: CongratsBoxActionTypes.CREATE_CONGRATS,
  payload: {
    file,
    heading,
    heading_ar,
    sub_text,
    sub_text_ar
  },
});

export const getCongratsBox = (): CongratsBoxActionType => ({
  type: CongratsBoxActionTypes.GET_CONGRATS,
  payload: {},
});

export const deleteCongratsBox = (id: string): CongratsBoxActionType => ({
  type: CongratsBoxActionTypes.DELETE_CONGRATS,
  payload: { id },
});
export const updateCongratsBox = (
  id: string | number,
  heading: string,
  heading_ar: string,
  sub_text : string,
  sub_text_ar : string,
  file: any
): CongratsBoxActionType => ({
  type: CongratsBoxActionTypes.UPDATE_CONGRATS,
  payload: {
    id,
    file,
    heading,
    heading_ar,
    sub_text,
    sub_text_ar
  },
});
